export const fileHasRequiredExtension = (fileName: string, extension: string): boolean => {
  const fileWithExtension: string[] = fileName.split('.');
  if (fileWithExtension.length === 1) {
    return false;
  } else {
    return fileWithExtension[fileWithExtension.length - 1].toUpperCase() === extension.toUpperCase();
  }
};
